
$controllers = {
	
	all : {
		
		_navigationUrl : '',
		_navigationPagesLoaded : 0,
		_taskCompleteHandler : function() { },
		
		init : function() {
			
			// initialise the cache storage objects
			$cached.initialise();
			
			// enforce singular login session across all browser windows; auto-logout users if their cookie has expired
			$controllers.login.enforceUniqueLoginSession();
			$controllers.login.enforceValidCookieSession();
			
			// proceed
			if (window.location.hash && !$views.all.authenticationRequiredForUrl(window.location.hash)) {
				
				// not logged in, but creating an account or other similar not-necessarily-logged-in situation where direct access to the page is required
				$controllers.all.loadNavigation(window.location.hash);
				
			} else if (!$models.login.getToken()) {
				
				// not logged in, so display the login page
				$controllers.login.display();
				
			} else {
				
				// the login auth key may or may not be valid... lets attempt to load our user details and see how we go
				$models.login.getMyUserDetails(function($data) {
					$models.login.cachedMyUserDetails = $data;
					if (window.location.hash.length > 3) {
						$controllers.all.loadNavigation(window.location.hash);
					} else {
						$controllers[$config.defaultPage].display();
					}
				});
				
			}
			
		},
		
		enforcePagePermissions : function($pageName) {
			//console.log('enforce'+$pageName);
			if ($views.all.authenticationRequiredForView($pageName) && !$models.login.getToken()) {
				$controllers.login.display();
				return false;
			}
			return true;
		},
		
		showPage : function($pageName, $bodyId, $params) {
			
			// UNLOAD the previous screen's variables and event handlers, if any
			$controllers.all.previousPage = $views.all.getCurrentScreen();
			if ($controllers.all.previousPage && $controllers[$controllers.all.previousPage].onUnload) {
				$controllers[$controllers.all.previousPage].onUnload();
			}
			
			// REMOVE errors/notices/warnings, if any
			$soupmail.modal.remove();
			
			// PERMISSION CHECK for requested page
			if (!$controllers.all.enforcePagePermissions($pageName)) {
				return false;
			}
			
			// LOAD the new screen's variables
			if ($controllers[$pageName].onLoad) {
				$controllers[$pageName].onLoad();
			}
			
			// DISPLAY the new screen
			$views.all.display($pageName, $bodyId, $params);
			
		},
		
		setNavigation : function($params) {
			
			$controllers.all.url = '#/' + encodeURIComponent($views.all.getCurrentScreen());
			
			if ($params != null) {
				
				if (($params.folder_ids != undefined) && ($params.folder_ids > 0)) {
					$controllers.all.url += '/folder-' + encodeURIComponent($params.folder_ids);
				}
				if (($params.email_id != undefined) && ($params.email_id > 0)) {
					$controllers.all.url += '/email-' + encodeURIComponent($params.email_id);
				}
				/*
				jQuery.each($params, function($key, $item) {
					if (($key != 'folder_ids') && ($key != 'max_results')) {
						$controllers.all.url += '/' + encodeURIComponent($key) + '::' + encodeURIComponent($item);
					}
				});
				*/
			}
			
			console.log('set navigation : '+$controllers.all.url);
			
			this._navigationUrl = $controllers.all.url;
			window.location.hash = $controllers.all.url;
			
		},
		
		loadNavigation : function($url) {
			
			// on first load of the UI after a refresh or direct link, keep GET parameters in place, but for further requests to loadNavigation(), we should remove the GET parameters
			$controllers.all._navigationPagesLoaded++;
			if (($controllers.all._navigationPagesLoaded > 1) && (document.location.href.indexOf('?') > 0) && !$config.testMode) {
				$soupmail.modal.enabled = false;
				$soupmail.notification.enabled = false;
				jQuery('#site-container').hide();
				document.location.href = document.location.protocol + '//' + document.location.host + document.location.pathname + document.location.hash;
				return false;
			}
			
			// test that this function was triggered correctly (i.e. if we're already on the requested page, do nothing)
			if ($url == this._navigationUrl) { return false; }
			if ($url.length < 3) { return false; }
			
			// set the current known url variable to this new url
			this._navigationUrl = $url;
			
			// extract the various parameters out of the url segments
			$controllers.all.urlSegments = $url.split('/');
			$controllers.all.urlSegments.shift();
			$controllers.all.toLoad_view = $controllers.all.urlSegments.shift();
			$controllers.all.toLoad_params = {};
			
			if ($controllers.all.urlSegments.length > 0) {
				jQuery.each($controllers.all.urlSegments, function($k, $segment) {
					if ($segment.indexOf('folder-') == 0) {
						$controllers.all.toLoad_params['folder_ids'] = $segment.replace('folder-', '');
					} else if ($segment.indexOf('email-') == 0) {
						var emailid = $segment.replace('email-', '');
						$soupmail.helpers.filter.$filters.specificEmailFilter = {id: emailid, subject: 'Specific email'};
						$controllers.all.toLoad_params['ids'] = emailid;
					} /*else {
						$vals = $segment.split('::');
						$key = $vals[0];
						$val = $vals[1];
						$controllers.all.toLoad_params[$key] = $val;
					}*/
				});
			}
			
			// now run the appropriate controller's display method, with $params set as necessary
			if (!$controllers[$controllers.all.toLoad_view]) {
				$soupmail.notification.error('The page you attempted to access does not exist');
				$controllers[$config.defaultPage].display();
				return false;
			}
			$controllers[$controllers.all.toLoad_view].display($controllers.all.toLoad_params);
			
		},
		
// TODO - REVIEW - CONSIDER MOVING TO BASE.VIEW ???
		help : function($display) {
			
			// Set height of guide area. ToggleSlide jumps if it doesn't know the actually element height.
			if ($('#help').css("display") == "none") {
				$('#help').each(function() {
				 $height = $(this).height();
				 $('#help .guide').css('height', $height);
				});
			}
			
			if ($display === true) {
				// removed to stop sliding effect of help
				//jQuery('#help').show(function() {
				//	if ($views.all.getCurrentScreen() == 'main') {
				//		$views.main.resizeLHScolumn(true);
				//	}
				//});
				jQuery('#help').show();
				if ($views.all.getCurrentScreen() == 'dashboard') {
					jQuery('#welcome-header').show();
				}
			} else {
				jQuery('#help').slideToggle(function() {
					if ($views.all.getCurrentScreen() == 'main') {
						$views.main.resizeLHScolumn(true);
					}
				});
				if ($views.all.getCurrentScreen() == 'dashboard') {
					jQuery('#welcome-header').slideToggle();
				}
			}
			
			if (jQuery('#help').css('display') == 'block') {
				$views.all.scrollToTop();
				
				// Connect Mailbox - ticked if me.json sync enabled
				if ($models.login.hasSyncEnabled()) {
					jQuery('#help .connect-mailbox').addClass('done');
				}
				
				// Create Folder & Favourite - ticked if favourite_folders.json contains 1 or more results
				$controllers.foldermanager.toggleHelpAreaFavouriteStatus();
				
				// Save Emails - ticked if contains 1 email
				$models.emails.getSize(function($total_result_count) {
					if ($total_result_count > 0) {
						jQuery('#help .save-emails').addClass('done');
					}
				});
				
				// Add Team Members & Share - ticked if more than 1 team member in users.json
				$models.users.getSize(function($data) {
					if ($data > 1) {
						jQuery('#help .add-team-settings').addClass('done');
					}
				});
				
			}
			
		},
		
		setTaskCompleteHandler : function($func) {
			
			this._taskCompleteHandler = $func;
			
		},
		
		runTaskCompleteHandler : function() {
			
			this._taskCompleteHandler();
			
		},
		
		handleEnterFormSubmissions : function($obj) {
			jQuery('form').each(function() {
				jQuery(this).find('input,textarea').focus(function() {
					jQuery(this).addClass('is-in-focus');
				});
				jQuery(this).find('input,textarea').blur(function() {
					jQuery(this).removeClass('is-in-focus');
				});
				jQuery(this).keyup(function(e) {
					var code = (e.keyCode ? e.keyCode : e.which);
					if (code == 13) {
						if (jQuery('.fullscreen_error_fg').size() > 0) {
							jQuery('.fullscreen_error_fg .button a').click(); // pressing enter while a popup error message is on the screen will close the popup
						} else if (jQuery('.is-in-focus').is('textarea')) {
							// do no special action when pressing enter inside a textarea...
						} else if (jQuery('.autocomplete_results').is(':visible')) {
							// do no special action while an autocomplete control is running and open...
						} else {
							jQuery(this).find('.submit-button').click(); // pressing enter inside a form will trigger the submit button to be clicked
						}
					}
				});
			});
		},
		
		unbindEnterFormSubmissions : function() {
			jQuery('form').unbind('keyup');
		},
		
		acceptUIversion : function(version) {
			jQuery.cookie('soup_accepted_version', version, { expires: 365 });
		},
		
		// this function only fires once (when we load the UI)
		checkVersion : function() {
			if ($config.mobile) {
				$controllers.all.refreshOnDeploy();
				return false;
			}
			if (!$config.enableVersionUpdateNotifications) {
				return false;
			}
			$models.all.getVersionInfo(function($data) {
				var thisUIname = $config.ui.name;
				var latestUI = $data.ui[thisUIname];
				if (!jQuery.cookie('soup_accepted_version')) {
					$controllers.all.acceptUIversion(latestUI.currentVersion);
				}
				if (parseFloat(jQuery.cookie('soup_accepted_version')) < parseFloat(latestUI.currentVersion)) {
					var message = (latestUI.upgradeMessageNormal ? latestUI.upgradeMessageNormal : "Soup Mail has been updated! View our blog to see what's changed.");
					$soupmail.notification.versionUpdate(message, latestUI.linkurl, latestUI.currentVersion);
				}
			});
		},
		
		// this function fires over and over repetitively (every minute)
		refreshOnDeploy : function() {
			if (!$config.enableVersionUpdateNotifications) {
				return false;
			}
			$models.all.getVersionInfo(function($data) {
				var thisUIname = $config.ui.name;
				var latestUI = $data.ui[thisUIname];
				if ($config.ui.version < latestUI.currentVersion) {
					if ($config.mobile) {
						// iPhone app users get a message appearing, since we can't force them to update, but we really want them to
						var message = (latestUI.upgradeMessageCritical ? latestUI.upgradeMessageCritical : 'A new version of Soup Mail is available.  We recommend you upgrade to the latest version.');
						$soupmail.notification.versionUpdate(message, latestUI.linkurl, latestUI.currentVersion);
					} else {
						// Web UI users get no choice, we detected a new deployment has just occurred, so force refresh their browser
						window.location.reload(true);
					}
				}
			});
		}
		
	}
	
};

// DO NOT REMOVE - USED FOR TESTING PURPOSES!
$controllers.tests = {
	display : function() {}
}

// TODO - CONSIDER MOVING TO ITS OWN CONTROLLER FILE
$controllers.login = {
	
	display : function() {
		
		$controllers.all.showPage('login', 'login');
		jQuery('#username, #password, #login_form button').removeAttr('disabled');
		
		// remember Username (if it is still stored in cookie from last time)
		if (jQuery.cookie('username') && !jQuery('#username').val()) {
			jQuery('#username').val(jQuery.cookie('username'));
			jQuery('#password').focus();
		} else if (!jQuery('#username').val()) {
			jQuery('#username').focus();
		} else {
			jQuery('#password').focus();
		}
		
		$('html').css('background', '#e9e9e7');
		
		$controllers.all.setNavigation();
		
	},
	
	login : function($username, $password) {
		
		// empty username or password?
		if (!$username) {
			return $soupmail.notification.error('Empty username not allowed');
		}
		if (!$password) {
			return $soupmail.notification.error('Empty password not allowed');
		}
		
		// disable login fields
		jQuery('#username, #password, #login_form button').attr('disabled', 'disabled');
		
		// attempt to login using the provided username and password
		$models.login.getAuth($username, $password, function($data) {
			
			// successful login occurred, so lets store that all important security token
			if ($config.mobile) {
				var $cookieExpiryOptions = {expires: 365};
			} else if (jQuery('#logout_tonight').is(':checked')) {
                		var $cookieExpiryOptions = {expires: new Date()};
                		$cookieExpiryOptions.expires.setHours(23,59,59,0);
                	} else {
                		var $cookieExpiryOptions = {};
                	}
			$models.login.setToken($data.token, $cookieExpiryOptions);
			$models.login.setUsername($username);
			
			// check to see if the user is activated
			if ($data.user.status != 'unactivated')  {
				
				// yes - activated - now load my user profile
				$models.login.cachedMyUserDetails = '';
				$models.login.getMyUserDetails(function($data) {
					
					// store the returned user details, as we'll need them later
					$models.login.cachedMyUserDetails = $data;
					
					// display the dashboard
					$controllers[$config.defaultPage].display();
					
				});
				
			} else {
				
				// no - not yet active - display activation required page
				$controllers.accountsetup.display();
				
			}
			
		}, function() {
			
			// login failed
			jQuery('#username, #password, #login_form button').removeAttr('disabled');
			$soupmail.notification.error('Login failed');
			$models.login.setToken('');
			
		});
		
	},
	
	logout : function ($apiRequestRequired, $cookieChangeRequired) {
		
		if ($apiRequestRequired !== false) { $apiRequestRequired = true; }
		if ($cookieChangeRequired !== false) { $cookieChangeRequired = true; }
		$models.login.logout($apiRequestRequired, $cookieChangeRequired);
		$controllers.login.display();
		jQuery('#password').val('');
		$cached.initialise(); // reset the cached storage objects for security reasons
		
	},
	
	enforceUniqueLoginSession : function() {
		
		setInterval(function() {
			if ($models.all.current_token && jQuery.cookie('soup_standalone') && ($models.all.current_token != jQuery.cookie('soup_standalone'))) {
				$controllers.login.logout(false, false);
				$soupmail.notification.message('You have been logged out of this session after you logged in separately in another tab/window within this web browser.');
			}
		}, 1000);
		
	},
	
	enforceValidCookieSession : function() {
		
		setInterval(function() {
			if ($models.all.current_token && !jQuery.cookie('soup_standalone')) {
				$controllers.login.logout(false, false);
				$soupmail.notification.message('Your login session has expired, please log in again.');
			}
		}, 10000);
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/controllers/base.controllers.js